import ContentContainer from "../components/ContentContainer";
import MainLayout from "../components/MainLayout";
import Typography from "../components/Typography";
import Button from "../components/Button";
import { useState } from "react";
import EmissionsDashboard from "../components/EmissionsDashboard";
import AssuranceDashboard from "../components/AssuranceDashboard";
import Separator from "../components/Separator";
import { ArrowSquareOut } from "@phosphor-icons/react";

const dashboardLinkUrl =
    "https://org56ef1225.crm11.dynamics.com/main.aspx?appid=5ca6e2cc-4f84-ee11-8179-000d3a0cd97b&pagetype=entitylist&etn=msdyn_dataanalyticsreport_sustainability&viewid=0f02dd33-6b20-ec11-b6e6-0022480a5ca9&viewType=1039";

const DashboardUIPage = () => {
    const [selectedTab, setSelectedTab] = useState<"emissions" | "assurance">(
        "assurance"
    );

    return (
        <MainLayout>
            <ContentContainer className="py-8">
                <Typography
                    variant="display-small"
                    component="h1"
                    className="text-deep-ocean-20"
                >
                    Insights
                </Typography>
            </ContentContainer>
            <ContentContainer className="flex pb-8">
                <Button
                    variant={
                        selectedTab === "assurance" ? "primary" : "outline"
                    }
                    onClick={() => setSelectedTab("assurance")}
                >
                    Assurance
                </Button>
                <Button
                    className="ml-4"
                    variant={
                        selectedTab === "emissions" ? "primary" : "outline"
                    }
                    onClick={() => setSelectedTab("emissions")}
                >
                    Emissions
                </Button>
                {selectedTab === "emissions" && (
                    <a
                        className="ml-auto h-9 flex items-center justify-center px-5 font-semibold text-sm rounded-3xl transition-colors focus:outline-none bg-transparent border border-surface-dark hover:bg-surface-light-1"
                        href={dashboardLinkUrl}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Dashboard <ArrowSquareOut className="ml-2" />
                    </a>
                )}
            </ContentContainer>
            <Separator className="mb-8" />
            {selectedTab === "emissions" ? (
                <EmissionsDashboard />
            ) : (
                <AssuranceDashboard />
            )}
        </MainLayout>
    );
};

export default DashboardUIPage;
